import React, { useContext } from 'react';
import Facets from './facets';
import { ListerContext } from '../../listerContext';
import { ListerActionTypes } from '../../listerReducer';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import useListerApi from '../../listerApiHooks';

function FacetsContainer(): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const [{ isListerDisabled, facets, pagination }, dispatch] = useContext(ListerContext);
  const { selectFacet } = useListerApi();

  const clearFacetsHandler = (): void => {
    selectFacet();
  };

  const facetsDisplayHandler = (): void => {
    dispatch({ type: ListerActionTypes.SET_IS_FACETS_DISPLAYED, isFacetsDisplayed: false });
  };

  return (
    <Facets
      facets={facets}
      isDisabled={isListerDisabled}
      clearFacetsHandler={clearFacetsHandler}
      facetsDisplayHandler={facetsDisplayHandler}
      messages={{
        title: formattedMessage({ id: 'search.nav.facets.top.heading.title', fallback: 'Filters' }),
        clearLabel: formattedMessage({ id: 'search.nav.facets.top.clear.label', fallback: 'Clear all' }),
        closeLabel: formattedMessage({ id: 'search.nav.facets.toggler.close.label', fallback: 'Close' }),
        closeIconLabel: formattedMessage({ id: 'search.nav.facets.toggler.close.icon.label', fallback: 'Close icon' }),
        viewLabel: formattedMessage({
          id: 'search.nav.facets.bottom.view.label',
          values: { 0: pagination.totalNumberOfResults },
          fallback: `View items (${pagination.totalNumberOfResults})`
        })
      }}
    />
  );
}

export default FacetsContainer;
